let mm = gsap.matchMedia();

gsap.timeline({
  scrollTrigger: {
    trigger: ".large-list",
    scrub: 1,
    markers: false,
    pinSpacing: false,
    pin: false,
    x: 0
  }
})
.to(".large-list", {x: -800})

gsap.from(".projects-hero > *", {
  y: -30,
  opacity: 0,
  delay: 1.5,
  pin: true,
  ease: "none"
});

